import type { ThemeConfig } from './types'
import { trailheadConfig } from '../generated/theme-presets'

/**
 * DOcurious Brand Color Palette
 *
 * Core Colors:
 * - Scout Green (Primary): #3D5A3C
 * - Honey (Accent): #D4A84B — XP, rewards, featured highlights
 *
 * Accent Colors:
 * - Coral: #E07B5A — Streaks, energy, alerts
 * - Sky: #5B8FA8 — Science, audio, secondary info
 * - Violet: #8B7BC8 — Adventure, creative challenges
 *
 * Neutrals:
 * - Cream: #FAF8F3 — Page backgrounds (not pure white)
 * - Ink: #1A1A1A — Primary text (not pure black)
 * - Stone: #555555 — Secondary text (AAA contrast on cream)
 * - Mist: #9A9A9A — Tertiary text
 *
 * Audience Accents:
 * - Coral (B2C): #E07B5A — Parents & Kids
 * - Honey (Schools): #D4A84B — Schools & Educators
 * - Sky (Providers): #5B8FA8 — Activity Providers
 *
 * Typography: Lexend (display) + Inter (body)
 */

export const defaultLayoutConfig: ThemeConfig['layout'] = trailheadConfig.layout

export const defaultThemeConfig: ThemeConfig = trailheadConfig
